import { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';

import dayjs from 'dayjs';

import { formatDate } from '../../../helpers/date';
import { getTaskStatus } from '../../../helpers/task';

import { DATE_FORMAT } from '../../../constants/common';

import styles from '../styles.module.scss';

import TaskDetailsItem from '../DetailsItem';
import { RELATION_PATH } from '../constants';

function TaskDetails({ task }) {
  const data = [
    {
      title: 'Title',
      data: task?.title
    },
    {
      title: 'Description',
      data: task?.description || '/'
    },
    {
      title: 'Status',
      data: task?.status || '/'
    },
    {
      title: 'Priority',
      data: task?.priority || '/'
    },
    {
      title: 'Due date',
      data: formatDate(task?.due_date)
    },
    {
      title: 'Remind date',
      data: task?.remind_at ? dayjs(task?.remind_at).format(DATE_FORMAT.DATETIME) : '/'
    }
  ];

  return (
    <div className={styles['modal-view-mode']}>
      {data.map(property => (
        <TaskDetailsItem key={property.title} title={property.title} data={property.data} />
      ))}

      {Array.isArray(task?.relations) && task?.relations?.length > 0 ? (
        <>
          <TaskDetailsItem title="Relations" data={task?.relationType} />

          <TaskDetailsItem
            title={task?.relationType}
            isDataHtml={false}
            data={task?.relations.map((r, i) => (
              <Fragment key={r.id}>
                <Link to={`/${RELATION_PATH[task?.relationType]}/${r.id}`}>{r.identifier}</Link>
                {i < task.relations.length - 1 && ', '}
              </Fragment>
            ))}
          />
        </>
      ) : (
        <TaskDetailsItem title="Relations" data="/" />
      )}

      <TaskDetailsItem title="Recurring type" data={task?.recurring_type || '/'} />

      {task?.users?.length > 0 ? (
        task?.users?.map((u, i) => {
          const status = getTaskStatus(u.status);
          const statusClass = styles[status.toLowerCase()];

          return (
            <TaskDetailsItem
              key={u.id}
              title={i === 0 ? 'Users' : ''}
              data={`<a href="mailto:${u.email}" class="text-lowercase">${u.email}</a> - <span class="${statusClass}">${status}</span>`}
            />
          );
        })
      ) : (
        <TaskDetailsItem title="Users" data="/" />
      )}
      {task?.external_emails?.length ? (
        <TaskDetailsItem
          title="External emails"
          data={`<span class="text-lowercase">${task.external_emails.join(', ')}</span>`}
        />
      ) : (
        <TaskDetailsItem title="External emails" data="/" />
      )}
    </div>
  );
}

export default memo(TaskDetails);
